import React, { useRef, useEffect } from 'react';
import {
  Marker,
  Popup,
  useMap
} from "react-leaflet";
import L from 'leaflet';
import { menu2icon } from './config';

/**
 * 95_7 マンション評価情報のポップアップ
 *
 * @param id
 * @param spot
 * @param latitude
 * @param longitude
 * @returns {JSX.Element|null}
 * @constructor
 */
const Component = ({id, spot, latitude, longitude}) => {
  
  const markerRef = useRef(null);
  
  useEffect(() => {
    
    // 変化があるごとにポップアップを自動表示
    // if (markerRef.current) {
      // markerRef.current.openPopup();
    // }
  });
  
  const icon = menu2icon[id]

  const iconUrl = new L.Icon({
    iconUrl: icon,
    iconRetinaUrl: icon,
    iconSize: [35, 35],
    iconAnchor: [17, 23],
    popupAnchor: [0, -50]
  });

  const map = useMap()
  const bounds = map.getBounds()
  const minlat = bounds._southWest.lat
  const maxlat = bounds._northEast.lat
  const minlng = bounds._southWest.lng
  const maxlng = bounds._northEast.lng

  const handleSpotData = () => {
    let ret = [];

    // ランク
    const rank = spot["Column83"] || 0;
    
    // 星で表す評価ランク部分のhtml
    let rankStars = [];
    
    for (let i=1; i <= 5; i++) {
      if (i <= rank) {
        rankStars.push(<span className="active">★</span>)
      } else {
        rankStars.push(<span>★</span>)
      }
    }
    
    const content = (
      <>
        <h2 className="u-fs-16 u-pb-xxs">{spot["Column1"] || ""}</h2>
        <div className="popup-scroll">
          <div className="u-pb-sm">
            <table className="c-tbl c-tbl-1">
              <thead>
              <tr>
                <th colSpan="4">基本情報</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <th className="u-txt-l">物件所在地（住居表示）</th>
                <td colSpan="3">〒<span className="u-pe-sm">{spot["Column5"] || ""}</span><span>{spot["Column6"] || ""}</span><span>{spot["Column7"] || ""}</span><span>{spot["Column8"] || ""}</span></td>
              </tr>
              <tr>
                <th className="u-txt-l">マンションID</th>
                <td>{spot["Column90"]}</td>
                <th className="u-txt-l">建物階数</th>
                <td>地上<span className="u-px-xs">{spot["Column9"] || ""}</span>階／地下<span className="u-px-xs">{spot["Column10"] || ""}</span>階</td>
              </tr>
              <tr>
                <th className="u-txt-l">竣工年月</th>
                <td>{spot["Column11"] || ""}</td>
                <th className="u-txt-l">総戸数</th>
                <td><span>{spot["Column3"] || ""}</span>戸</td>
              </tr>
              <tr>
                <th className="u-txt-l">管理委託形態</th>
                <td>{spot["Column23"] || ""}</td>
                <th className="u-txt-l">委託管理業者名</th>
                <td>{spot["Column24"] || ""}</td>
              </tr>
              <tr>
                <th className="u-txt-l">初回公開日</th>
                <td>{spot["Column86"] || ""}</td>
                <th className="u-txt-l">期中更新日</th>
                <td>{spot["Column88"] || ""}</td>
              </tr>
              </tbody>
            </table>
            <table className="c-tbl c-tbl-1">
              <thead>
              <tr>
                <th colSpan="8">詳細情報</th>
              </tr>
              </thead>
              <tbody>
              <tr className="td-bg">
                <th rowSpan="3" className="u-txt-l">共用施設</th>
                <td>集会所</td>
                <td>ゲストルーム</td>
                <td>キッズルーム</td>
                <td>来客用駐車場</td>
                <td>バイク置場</td>
                <td colSpan="2">駐輪場</td>
              </tr>
              <tr>
                <td>{spot["Column13"] ? "○" : "-"}</td>
                <td>{spot["Column14"] ? "○" : "-"}</td>
                <td>{spot["Column15"] ? "○" : "-"}</td>
                <td>{spot["Column17"] ? "○" : "-"}</td>
                <td>{spot["Column18"] ? "○" : "-"}</td>
                <td colSpan="2">{spot["Column19"] ? "○" : "-"}</td>
              </tr>
              <tr>
                <td colSpan="7">{spot["Column21"] || "　"}</td>
              </tr>
              <tr className="td-bg">
                <th rowSpan="3" className="u-txt-l">共用部に<br />付保している<br />損害保険</th>
                <td>火災保険</td>
                <td>地震保険</td>
                <td>水災担保特約</td>
                <td colSpan="2">個人賠償責任保険特約</td>
                <td colSpan="2">施設賠償責任保険特約</td>
              </tr>
              <tr>
                <td>{spot["Column27"] ? "○" : "-"}</td>
                <td>{spot["Column29"] ? "○" : "-"}</td>
                <td>{spot["Column30"] ? "○" : "-"}</td>
                <td colSpan="2">{spot["Column31"] ? "○" : "-"}</td>
                <td colSpan="2">{spot["Column32"] ? "○" : "-"}</td>
              </tr>
              <tr>
                <td colSpan="7">{spot["Column34"] || "　"}</td>
              </tr>
              <tr>
                <th className="u-txt-l">契約保険会社名</th>
                <td colSpan="2">{spot["Column35"] || ""}</td>
                <th className="u-txt-l" colSpan="2">修繕積立金の徴収</th>
                <td colSpan="3">{spot["Column63"] || ""}</td>
              </tr>
              <tr>
                <th className="u-txt-l">住宅宿泊事業</th>
                <td>{spot["Column41"] || ""}</td>
                <th className="u-txt-l">ペットの飼育</th>
                <td>{spot["Column45"] || ""}</td>
                <th className="u-txt-l">専有部工事の制限</th>
                <td>{spot["Column46"] || ""}</td>
                <th className="u-txt-l">楽器など音に関する制限</th>
                <td>{spot["Column47"] || ""}</td>
              </tr>
              </tbody>
            </table>
          </div>

          <h2 className="apartment-title">マンション管理状態の評価</h2>
          <div className="u-fs-10 u-pb-xs">
            マンションの管理状態について専門家（管理業務主任者又はマンション管理士）が客観的な評価基準を基に評価した結果です。
            <a href="https://www.kanrikyo.or.jp/evaluation/#about" target="_blank" className="u-link">マンション管理適正評価制度とは？</a>
          </div>
          <div className="apartment-wrap">
            <div className="apartment-point">
              <dl className="apartment-value">
                <dt>管理評価総獲得ポイント</dt>
                <dd><span className="point">{spot["Column84"] || ""}</span>Pt / 100Pt</dd>
              </dl>
            </div>
            <div className="apartment-rank">
              <dl className="apartment-value">
                <dt>総合ランク</dt>
                <dd>
                  {rankStars}
                </dd>
              </dl>
            </div>
          </div>
          <table className="c-tbl c-tbl-1">
            <tbody>
            <tr className="td-bg">
              <th>管理評価主要5項目</th>
              <th>評価の視点</th>
            </tr>
            <tr>
              <td>
                <ul className="apartment-value-five">
                  <li>1</li>
                  <li>管理体制</li>
                  <li><span className="point">{spot["Column78"] || ""}</span><span className="u-clr-gray">Pt / 20Pt</span></li>
                </ul>
              </td>
              <td>管理者等の設置、総会の開催状況、議事録の保管状況、管理規約の整備状況など</td>
            </tr>

            <tr className="td-bg">
              <td>
                <ul className="apartment-value-five">
                  <li>2</li>
                  <li>建築・設備</li>
                  <li><span className="point">{spot["Column79"] || ""}</span><span className="u-clr-gray">Pt / 20Pt</span></li>
                </ul>
              </td>
              <td>法定点検の実施状況、点検記録の有無、長期修繕計画の作成、修繕履歴の保管状況など</td>
            </tr>

            <tr>
              <td>
                <ul className="apartment-value-five">
                  <li>3</li>
                  <li>管理組合収支</li>
                  <li><span className="point">{spot["Column80"] || ""}</span><span className="u-clr-gray">Pt / 40Pt</span></li>
                </ul>
              </td>
              <td>管理費会計・修繕積立金会計の決算状況、滞納管理費等への対策、修繕に関する資金計画の状況など</td>
            </tr>

            <tr className="td-bg">
              <td>
                <ul className="apartment-value-five">
                  <li>4</li>
                  <li>耐震診断</li>
                  <li><span className="point">{spot["Column81"] || ""}</span><span className="u-clr-gray">Pt / 10Pt</span></li>
                </ul>
              </td>
              <td>耐震診断の実施の有無、耐震診断結果、改修予定など</td>
            </tr>

            <tr>
              <td>
                <ul className="apartment-value-five">
                  <li>5</li>
                  <li>生活関連</li>
                  <li><span className="point">{spot["Column82"] || ""}</span><span className="u-clr-gray">Pt / 10Pt</span></li>
                </ul>
              </td>
              <td>設備等異常時の緊急対応の体制、消防訓練の実施状況防災マニュアル作成や災害時における安否確認体制など</td>
            </tr>
            </tbody>
          </table>
        </div>
      </>
    );
     
    ret.push(content)
    
    return ret;
  }

  if(latitude > minlat && latitude < maxlat && longitude > minlng && longitude < maxlng){


    return (
      <>
        <Marker
          position={[latitude, longitude]}
          icon={iconUrl}
          ref={markerRef}
        >
          <Popup
            className={'vis_95_7'}
            autoPan={true}
            keepInView={true}   
            autoPanPadding={L.point(30, 70)}
            minWidth={300}
            closeOnClick>
            {
              handleSpotData()
            }
          </Popup>
        </Marker>

      </>
    );
  }else{
    return null
  }
}

export default Component;
